import { Route } from '@angular/router';
import { authRoutes, hasTenant, tenantGuard } from '@mds/ngx-auth';
import { deploymentRoutes } from './components/deployment/deployment.routes';
import { driverRoutes } from './components/driver/driver.routes';
import { driverPlanningRoutes } from './components/driver-planning/driver-planning.routes';
import { shiftRoutes } from './components/shift/shift.routes';
import { vehicleRoutes } from './components/vehicle/vehicle.routes';
import { vehiclePlanningRoutes } from './components/vehicle-planning/vehicle-planning.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: 'error/:code',
        loadComponent: () =>
          import('@mds/ngx-layout').then((m) => m.ErrorPageComponent),
      },
      authRoutes,
      {
        path: '',
        canMatch: [hasTenant],
        canActivate: [tenantGuard],
        children: [
          {
            path: ':tenant',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./components/home/home.component').then(
                    (m) => m.HomeComponent,
                  ),
              },
              {
                path: 'shifts',
                children: shiftRoutes,
              },
              {
                path: 'vehicles',
                children: vehicleRoutes,
              },
              {
                path: 'vehicleplanning',
                children: vehiclePlanningRoutes,
              },
              {
                path: 'drivers',
                children: driverRoutes,
              },
              {
                path: 'driverplanning',
                children: driverPlanningRoutes,
              },
              {
                path: 'deployments',
                children: deploymentRoutes,
              },
            ],
          },
        ],
      },
      {
        path: '**',
        redirectTo: '/error/404',
      },
    ],
  },
];
